import { render, staticRenderFns } from "./salesView.vue?vue&type=template&id=78ec2640&"
import script from "./salesView.vue?vue&type=script&lang=js&"
export * from "./salesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports